import { render, staticRenderFns } from "./CallPhone.vue?vue&type=template&id=e002cbe0&scoped=true&"
import script from "./CallPhone.vue?vue&type=script&lang=js&"
export * from "./CallPhone.vue?vue&type=script&lang=js&"
import style0 from "./CallPhone.vue?vue&type=style&index=0&id=e002cbe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e002cbe0",
  null
  
)

export default component.exports